import styled from 'styled-components';
import ImageImplementation from './implementation/ImageImplementation';
var ImageComponent = styled(ImageImplementation)(function (props) {
    var styleObject = props.theme.coreThemes.image.getStyleObjectBuilder(props, 'height', 'width', 'border', 'circle', 'position')
        .withCustomStyle(props.customStyle)
        .build();
    return styleObject;
});
export default ImageComponent;
//# sourceMappingURL=ImageComponent.js.map